interface WhatsAppBrandIconProps {
  size?: number;
  color?: string;
}

import { WHATSAPP_BRAND_PATH } from '@/components/icons/whatsapp-brand-path';

/** Official WhatsApp brand mark (phone-in-bubble). */
export default function WhatsAppBrandIcon({
  size = 20,
  color = '#25D366',
}: WhatsAppBrandIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden
      data-testid="whatsapp-brand-icon"
    >
      <path d={WHATSAPP_BRAND_PATH} />
    </svg>
  );
}
